import PageTypeUtils from 'app/utils/pageType';
import { getMetricsForPageType as getPageMetricsForPageType } from 'app/modules/insights/modules/pagePerformance/utils/metricProperty';
import { getMetricsForPageType as getPostsMetricsForPageType } from 'app/modules/insights/modules/postsPerformance/utils/metricProperty';
import i18n from 'app/utils/i18n';
import { SectionType } from 'types/Report';
import { Page } from 'app/modules/insights/types/Page';

export const ReportUtils = {
  findPageByProfile: (
    pages: Page[],
    profile: { profile_id: number; profile_type: string },
  ): Page | undefined =>
    pages.find(
      (page) =>
        ReportUtils.getIdFromComposedId(page.id) === profile.profile_id &&
        PageTypeUtils.getNameFromNumber(page._type) === profile.profile_type,
    ),
  getIdFromComposedId: (id: string) => Number(atob(id).split('-')[1]),
  getMetricOptions: ({
    pageType,
    type,
  }: {
    pageType: string;
    type: SectionType;
  }) => {
    const pageTypeNumber = PageTypeUtils.getNumberFromName(pageType);
    const metrics =
      type === 'page_performance'
        ? getPageMetricsForPageType(pageTypeNumber)
        : getPostsMetricsForPageType(pageTypeNumber);
    return Object.values(metrics).map((metric) => ({
      value: metric.key,
      label: i18n.t(metric.title),
    }));
  },
};
